export const SaleEndDate = new Date('2024-12-04T00:00:00Z');
